
import { datetime, Schema } from 'simpli-web-sdk'
import DeliverySacResponse from '@/model/response/DeliverySacResponse'

export default (model: DeliverySacResponse): Schema => ({
    nroNotaFiscal: {
        content: model.nroNotaFiscal,
    },

    nroCTE: {
        textContent: model.cargaInfo && model.cargaInfo.nroCte ? model.cargaInfo.nroCte : '',
    },

    dataPrevisao: {
        content: datetime(model.dataPrevisao),
    },

    danfe: {
        content: model.danfe,
    },

    attempt: {
        content: model.attempt,
    },

    status: {
        content: model.nomeStatus,
    },

    event: {
        content: model.event,
    },

    date: {
        content: datetime(model.date),
    },

    shipperName: {
        content: model.shipperName,
    },

    manifest: {
        content: model.manifest,
    },

    dataPrevisaoAtualizada: {
        textContent: model.showPrevisaoReal ?
          (model.cargaInfo && model.cargaInfo.dataPrevisaoAtualizada ?
            datetime(model.cargaInfo.dataPrevisaoAtualizada) :
            (model.dataPrevisao ? datetime(model.dataPrevisao) : '')) : null,
    },

    observacaoPrevisao: {
        textContent: model.showPrevisaoReal ?
          (model.cargaInfo && model.cargaInfo.observacaoPrevisao ?
            model.cargaInfo.observacaoPrevisao : '') : null,
    },
})
